import InfoIcon from "shared/icons/status-icons/info-icon.svg?react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";

export const InfoTooltip = ({ text }: { text: string }) => {
  return (
    <Tooltip>
      <TooltipTrigger as="div" className="cursor-pointer text-left">
        <InfoIcon className="h-5 w-5 text-content-100" />
      </TooltipTrigger>

      <TooltipContent className="max-w-[480px] rounded-lg z-[50] border bg-alpha-800 p-4 text-sm text-content-1000-inverted shadow-xs">
        {text}
      </TooltipContent>
    </Tooltip>
  );
};
